import getSessionContext from "./session-context/one-web-irw/getSessionContext";

const initPurchaseAgent = () => {
  if (window.ikea) {
    /* Temporary hack to disable the events sent from Product presentation
     */
    if (window.ikea.purchaseAgent === undefined) {
      window.ikea.purchaseAgent = {
        agentLoaded: true,
      };
    }
  }
};

const initCartHandler = () => {
  require.ensure(
    [],
    (require) => {
      const initPurchaseHandler =
        require("./purchase/init-purchase-handler").default;
      const { purchaseFunc, purchaseHandler } = require("./purchase/irw");
      const rangePurchaseHandler = new purchaseHandler(
        getSessionContext,
        purchaseFunc
      );
      initPurchaseHandler(rangePurchaseHandler);
    },
    "cart-handler"
  );
};

const initFavouriteHandler = () => {
  require.ensure(
    [],
    (require) => {
      const initListHandler = require("./purchase/list-handler").default;
      const listService = require("./shoppinglist/irw");
      initListHandler(getSessionContext, listService);
    },
    "list-handler"
  );
};

const registerPurchaseMiddleware = () => {
  initPurchaseAgent();
  initCartHandler();
  initFavouriteHandler();
};

export default registerPurchaseMiddleware;
